/**
 * Transform interest rates between yearly/monthly
 * @param value input value
 * @param input input type (monthly, yearly)
 * @param output output type (monthly, yearly)
 */
export type InterestRateTypes = 'm' | 'y';
export const rateConversion = (
  value: number, input: InterestRateTypes, output: InterestRateTypes,
) => {
  // eslint-disable-next-line no-restricted-properties
  const getRes = (n: number) => Math.pow(1 + value, n) - 1;
  switch ((input[0] + output[0]).toLowerCase()) {
    case 'my': return getRes(12);
    case 'ym': return getRes(1 / 12);
    default: break;
  }
  return value;
};
